import { useTranslation, Trans } from "react-i18next";

import mob from '../../img/SpecialOffers/mob.png'
import main from '../../img/SpecialOffers/main.png'

import { LinkContext } from "../../LinkProvider";
import { useContext } from "react";

function Main () {

    const { link } = useContext(LinkContext);

    const { t } = useTranslation();
 
    return(
        <div className="relative pt-[40px] overflow-hidden">
            <div className="max-w-[1220px] relative xl:mx-auto mx-[20px] h-[630px] sm:h-[689px] bg-[#F1F1F1]">
                <img src={main} className="absolute bottom-0 hidden sm:block" alt="" />
                <img src={mob} className="block sm:hidden w-full absolute bottom-0" alt="" />
                <div className="flex flex-col xl:flex-row px-[20px] xl:px-[80px] py-[40px] xl:py-[70px] justify-between relative">
                    <div className="flex flex-col items-start   ">
                        <p className="zen-dots text-[#1E1C21] xl:text-[36px] leading-[1.2] text-[24px]">{t('offers.1')}</p>
                        <p className="mt-[6px] xl:mt-[20px] xl:max-w-[419px] text-[#1E1C21] text-[16px] xl:text-[20px] zen-dots">{t('offers.2')}</p>
                        <a href={link} className="xl:mt-[350px] hidden xl:block">
                            <div className={`px-[70px] bg-[#35AB33] py-[16px] flex items-center justify-center rounded-[60px] hover:scale-[0.95] transition-all`}>
                                <p className={`uppercase ibm-plex text-[14px] text-[#FFFFFF] xl:text-[16px]`}>{t('offers.5')}</p>
                            </div>
                        </a>
                    </div>
                    <div className="mt-[20px] xl:mt-0">
                        <p className="max-w-[498px] text-[12px] xl:text-[14px] text-[#000000B2] ibm-plex">{t('offers.3')}</p>
                        <p className="max-w-[498px] text-[12px] xl:text-[14px] text-[#000000B2] ibm-plex mt-[12px] xl:mt-[18px] font-[600]">{t('offers.4')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Main;